import { CarFront, FileText, Megaphone } from 'lucide-react';
import { NavLink } from 'react-router';
import { uk } from '../i18n/uk';
import { cx } from '../lib/cx';
import { haptic } from '../telegram';

const TABS = [
  { to: '/', label: uk.tabs.fleet, icon: CarFront, end: true },
  { to: '/channels', label: uk.tabs.channels, icon: Megaphone, end: false },
  { to: '/template', label: uk.tabs.template, icon: FileText, end: false },
] as const;

/** Bottom navigation for the three top-level screens (docs/UI.md 4). */
export function TabBar() {
  return (
    <nav className="fixed inset-x-0 bottom-0 z-40 border-t border-separator/60 bg-section/95 pb-[env(safe-area-inset-bottom)] backdrop-blur">
      <ul className="flex">
        {TABS.map(({ to, label, icon: Icon, end }) => (
          <li key={to} className="flex-1">
            <NavLink
              to={to}
              end={end}
              onClick={() => haptic.selection()}
              className={({ isActive }) =>
                cx(
                  'flex h-14 flex-col items-center justify-center gap-0.5 text-[11px]',
                  isActive ? 'text-button' : 'text-hint',
                )
              }
            >
              <Icon className="size-6" aria-hidden />
              {label}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
